import styles from './TermsAndConditionsModal.module.css';

export const TermsContent = () => (
  <div className={styles.termsBody}>
    <section className={styles.termsSection}>
      <h3 className={styles.sectionHeading}>1. General Information</h3>
      <p className={styles.sectionParagraph}>
        These Terms and Conditions govern the purchase and use of ski passes issued by [Resort/Company Name] (&quot;the Resort&quot;). By purchasing or using a ski pass, the holder agrees to comply with these Terms and Conditions as well as all posted resort rules and safety regulations.
      </p>
    </section>

    <section className={styles.termsSection}>
      <h3 className={styles.sectionHeading}>2. Validity and Use</h3>
      <ul className={styles.bulletList}>
        <li>A ski pass is personal and non-transferable, unless otherwise stated (e.g., Family or Group Bundles).</li>
        <li>Each pass is valid only for the period, area, and number of days specified at the time of purchase.</li>
        <li>Ski passes must be carried at all times while using lifts and may be inspected by resort staff at any time.</li>
        <li>Unauthorized use, resale, or duplication of a ski pass may result in confiscation without refund.</li>
      </ul>
    </section>

    <section className={styles.termsSection}>
      <h3 className={styles.sectionHeading}>3. Identification</h3>
      <ul className={styles.bulletList}>
        <li>Pass holders must provide valid identification upon request by resort personnel.</li>
        <li>Adding a name to a ski pass is optional but recommended to help identify users, especially for large groups or to avoid issues during ski pass verification.</li>
      </ul>
    </section>

    <section className={styles.termsSection}>
      <h3 className={styles.sectionHeading}>4. Pricing and Payment</h3>
      <ul className={styles.bulletList}>
        <li>Prices are stated in [currency] and include applicable taxes unless otherwise specified.</li>
        <li>The Resort reserves the right to adjust prices or discounts at any time before purchase confirmation.</li>
      </ul>
    </section>
  </div>
);
